import { useEffect, useState } from "react";
import { api, money, when } from "../../lib/api";

export default function AdminDashboard({ setTab }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/summary").then(r => setS(r.data)).catch(() => setS({ error: true })); }, []);
  if (!s) return <div className="admin-section">Loading…</div>;
  if (s.error) return <div className="admin-section" data-testid="admin-access-denied">Admin access denied</div>;
  const stats = [["users", s.users, "Total users"], ["pending-deposits", s.pending_deposits, "Pending deposits"], ["pending-withdrawals", s.pending_withdrawals, "Pending withdrawals"],
    ["approved-deposits", money(s.approved_deposits), "Approved deposits"], ["approved-withdrawals", money(s.approved_withdrawals), "Approved withdrawals"], ["active-bonuses", s.active_bonuses, "Active bonuses"]];
  return (
    <>
      <div className="admin-stats six">{stats.map(([id, v, l]) => <div key={id} data-testid={`stat-${id}`}><b>{v}</b><span>{l}</span></div>)}</div>
      <section className="admin-section"><div className="section-head"><h2>Recent transactions</h2><button onClick={() => setTab("transactions")} data-testid="admin-goto-transactions">Review all</button></div>
        <p className="report-note">Current Win Go period · <b data-testid="dashboard-current-period">{s.current_period || "paused"}</b></p>
        {s.recent.map(tx => <div className="admin-tx" key={tx.transaction_id}><div><b>{tx.type}</b><small>{tx.transaction_id} · {when(tx.created_at)}</small></div><strong>{money(tx.amount)}</strong><span className={`status ${tx.status}`}>{tx.status}</span></div>)}
      </section>
    </>
  );
}
